import { useTimeStore } from "../../stores/time";

const toInputValue = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const ChevronLeftIcon = () => (
  <svg
    aria-hidden="true"
    className="size-4"
    fill="none"
    stroke="currentColor"
    strokeWidth={2.2}
    viewBox="0 0 24 24"
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
  </svg>
);

const ChevronRightIcon = () => (
  <svg
    aria-hidden="true"
    className="size-4"
    fill="none"
    stroke="currentColor"
    strokeWidth={2.2}
    viewBox="0 0 24 24"
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
  </svg>
);

const navButtonClassName =
  "inline-flex size-10 shrink-0 cursor-pointer items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-500 shadow-sm transition-colors hover:border-indigo-200 hover:bg-indigo-50 hover:text-indigo-700 focus-visible:ring-2 focus-visible:ring-indigo-200 focus-visible:outline-none";

const DatePicker = () => {
  const { selectedDate, setSelectedDate, updateWeek } = useTimeStore();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const [year, month, day] = event.target.value.split("-").map(Number);
    if (!year || !month || !day) return;
    const newDate = new Date(year, month - 1, day);
    setSelectedDate(newDate);
    updateWeek(newDate);
  };

  const handlePreviousWeek = () => {
    const newDate = new Date(selectedDate);
    newDate.setDate(newDate.getDate() - 7);
    setSelectedDate(newDate);
    updateWeek(newDate);
  };

  const handleNextWeek = () => {
    const newDate = new Date(selectedDate);
    newDate.setDate(newDate.getDate() + 7);
    setSelectedDate(newDate);
    updateWeek(newDate);
  };

  return (
    <div className="flex items-center gap-1.5">
      <button
        type="button"
        onClick={handlePreviousWeek}
        aria-label="Semaine précédente"
        title="Semaine précédente"
        className={navButtonClassName}
      >
        <ChevronLeftIcon />
      </button>
      <input
        type="date"
        value={toInputValue(selectedDate)}
        aria-label="Date de la semaine"
        className="h-10 w-[10.5rem] rounded-xl border border-slate-200 bg-white px-3 font-Nunito text-sm text-slate-800 shadow-sm transition-colors focus:border-indigo-300 focus:ring-2 focus:ring-indigo-100 focus:outline-none"
        onChange={handleChange}
      />
      <button
        type="button"
        onClick={handleNextWeek}
        aria-label="Semaine suivante"
        title="Semaine suivante"
        className={navButtonClassName}
      >
        <ChevronRightIcon />
      </button>
    </div>
  );
};

export default DatePicker;
